import React from "react";
import "./about.scss";
import logo from "../../Media/FotoAbout.webp";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCheckCircle} from "@fortawesome/free-solid-svg-icons";

const handleConsultationClick = () => {
  const whatsappLink =
    "https://api.whatsapp.com/send/?phone=6285136087667&text=Halo%20Alex,%20Saya%20bisa%20minta%20detail%20Katalog,%20Simulasi,%20dan%20Promo%20terbaru%20Produk%20Grand%20Eastern%20(About)%20https://marketinggrandeastern.com/&type=phone_number&app_absent=0";
  window.open(whatsappLink, "_blank");
};

const about = () => {
  return (
    <div id="about" className="container-about">
      <div className="container-deskripsi">
        <div className="judulsumbog">
          <h1>Evolving Together, Shaping the Future of Living</h1>
        </div>
        <div className="deskripsi-about">
          Grand Eastern adalah perumahan eksklusif yang terletak di Keputih,
          Surabaya Timur, dikembangkan oleh Eastern Land Group. Proyek ini
          menawarkan hunian premium dengan konsep resor bintang lima pertama di
          Jawa Timur, dirancang khusus untuk memenuhi kebutuhan dan selera kaum
          milenial dan Gen Z. Perumahan ini menyediakan berbagai tipe unit,
          termasuk rumah dua lantai dengan tiga kamar tidur, dengan harga mulai
          dari Rp895 juta hingga Rp1,58 miliar. Fasilitas yang ditawarkan
          meliputi lapangan basket, area BBQ, clubhouse, taman hijau, kolam
          renang anak, jalur lari, area bermain, area ritel, keamanan 24 jam,
          kolam renang, pusat kebugaran, dan lapangan tenis.
        </div>
      </div>
      <div className="rowcontainer">
        <div className="featurelist">
          <div className="feature">
            <FontAwesomeIcon icon={faCheckCircle} />
            <span style={{color: "black"}}>
              &nbsp;&nbsp; Strategic Location
            </span>
          </div>
          <div className="feature">
            <FontAwesomeIcon icon={faCheckCircle} />
            <span style={{color: "black"}}>
              &nbsp;&nbsp;Engage with Daily Life Activity
            </span>
          </div>
          <div className="feature">
            <FontAwesomeIcon icon={faCheckCircle} />
            <span style={{color: "black"}}>
              &nbsp;&nbsp;Connecting With Nature
            </span>
          </div>

          <div className="feature">
            <FontAwesomeIcon icon={faCheckCircle} />
            <span style={{color: "black"}}>&nbsp;&nbsp;Elegant Lifestyle</span>
          </div>

          <div className="feature">
            <FontAwesomeIcon icon={faCheckCircle} />
            <span style={{color: "black"}}>&nbsp;&nbsp;Endless Facilities</span>
          </div>
          <div className="feature">
            <FontAwesomeIcon icon={faCheckCircle} />
            <span style={{color: "black"}}>
              &nbsp;&nbsp;Perfect Modern Luxury & luxurious Residence
            </span>
          </div>
          <div className="button">
            <div className="container-wa">
              <button
                className="buttonpenawaran"
                onClick={handleConsultationClick}>
                Learn More
              </button>
            </div>
          </div>
        </div>
        <div className="logo-about">
          <img
            className="gambar-logo"
            src={logo}
            alt="logo-summarecon-serpong"
          />
        </div>
      </div>
    </div>
  );
};

export default about;
